import React from 'react';
import { connect } from 'react-redux';
import { cleanPersistedStorage } from '~redux_related/GENERAL/actionCreators';
import { setVersion } from '~redux_related/ui/actionCreators';
import { version } from '../package.json';

function Cleaner({ ui, setVersion, cleanPersistedStorage }) {
    console.log('+++CLEANER+++');
    React.useEffect(() => {
        console.log('cashed version', ui.version);
        console.log('version', version);
        if (ui.version !== version) {
            console.log('+++CLEARED+++');
            cleanPersistedStorage();
            setVersion(version);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
}

const mapStateToProps = (state) => ({
    device: state.ui.device,
    ui: state.ui,
});

const mapDispatchToProps = (dispatch) => ({
    cleanPersistedStorage: () => dispatch(cleanPersistedStorage()),
    setVersion: (version) => dispatch(setVersion(version)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Cleaner);



// WEBPACK FOOTER //
// ./src/cleaner.js